// extracted by mini-css-extract-plugin
module.exports =  {"show-more-less":"dDTRGBG","showMoreLess":"dDTRGBG"};